import "../resource_collection/behavior.js";

// Each behavior must be registered with the name of the component template
class ServicesBehavior extends Sparkle.PageBuilder.Components.ResourceCollectionAbstractBehavior {}
ServicesBehavior.register("services");
